import { render } from "./auditingDatabase.vue?vue&type=template&id=068db73d&scoped=true"
import script from "./auditingDatabase.vue?vue&type=script&lang=js"
export * from "./auditingDatabase.vue?vue&type=script&lang=js"

import "./auditingDatabase.vue?vue&type=style&index=0&id=068db73d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068db73d"]])

export default __exports__